module.exports = __webpack_public_path__ + "img/Voucher Image.b6e47fe3.jpg";